import React, { useEffect } from "react";
import { Grid, FormControlLabel, Button, Checkbox } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import LookupPopup from "./LookupPopup";
import ApiClient from "../../../../utils/ApiClient";

function LookupColumnConfig(props) {
  const {
    values,
    handleChange,
    setFieldValue,
    validateExpressionFormula,
    store,
  } = props;
  const listIds = [values.list_id, values.options.source_list_id];
  const queryString = values.options.query_string;
  let criteria = "";
  if (queryString != undefined && queryString.length == 0) {
    criteria = queryString;
  } else if (queryString != undefined && queryString.length > 0) {
    criteria = { query_string: values.options.query_string, query_tree: {} };
  }
  const [lookupCriteria, setLookupCriteria] = React.useState(criteria);
  useEffect(() => {
    async function getQueryTree() {
      const resp = await ApiClient.List.validateFilterQuery(
        listIds.join(","),
        queryString
      );
      if (resp.success) {
        criteria.query_tree = resp.data;
      }
    }
    if (queryString != undefined && queryString.length > 0) {
      getQueryTree();
    }
  }, [lookupCriteria]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const setReviseButtonRef = React.useCallback(
    (node) => {
      if (node !== null && !values.options.source_column_id) {
        setAnchorEl(node);
      }
    },
    [values.options.source_column_id]
  );
  return (
    <Grid item xs={12}>
      <Button
        ref={setReviseButtonRef}
        onClick={(e) => {
          if (!values.column_name) {
            return Ext.Msg.alert("Error", "Please enter column name");
          }
          setAnchorEl(e.target);
        }}
        variant="outlined"
      >
        Revise
      </Button>
      <LookupPopup
        anchorEl={anchorEl}
        store={store}
        values={values}
        onClose={() => setAnchorEl(null)}
        onSave={(options) => {
          if (!options.source_column_id) {
            window.appStore.notificationStore.showNotification(
              "Please fill all details",
              "error"
            );
            return;
          }
          setFieldValue("options", options);
          setAnchorEl(null);
        }}
        columnName={values.column_name}
        lookupCriteria={lookupCriteria}
      />
    </Grid>
  );
}

export default inject(({ store: appStore }) => ({
  // store: appStore.addColumnStore,
  //   validateExpressionFormula: appStore.addColumnStore.validateExpressionFormula,
}))(observer(LookupColumnConfig));
